import DatatableProducts from "../../components/datatableProducts.js/DatatableProducts";
import { Navbar } from "../../components/navbar/Navbar";
import { Sidebar } from "../../components/sidebar/Sidebar";
import "./List.css";

const ListProd = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <DatatableProducts />
      </div>
    </div>
  );
};

export default ListProd;

